<template>
  <div class="authorith-nothing">
    <img class="no-authority" src="../../../assets/no-authority.png">
    <p class="tips">无此权限，请联系管理员添加</p>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
export default {

  data() {
    return {
    }
  },

  created() {
    config()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.authorith-nothing {
  flex: 1;
  @include flex-column-center;
  justify-content: center;
  .no-authority {
    width: 133px;
    height: 116px;
  }
  .tips {
    margin-top: 30px;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
  }
}
</style>
